// import React, { useEffect, useState } from "react";

// const DropdownCheckbox = ({ departments, selectedRow, setSelectedRow }) => {
//     const [isOpen, setIsOpen] = useState(false);

//     // Parse department_id string to array when the component mounts or when selectedRow changes
//     useEffect(() => {
//         if (typeof selectedRow.department_id === "string") {
//             try {
//                 const parsedDepartmentId = JSON.parse(selectedRow.department_id);
//                 setSelectedRow((prevSelectedRow) => ({
//                     ...prevSelectedRow,
//                     department_id: Array.isArray(parsedDepartmentId) ? parsedDepartmentId : [],
//                 }));
//             } catch (error) {
//                 console.error("Failed to parse department_id:", error);
//             }
//         }
//     }, [selectedRow.department_id, setSelectedRow]);

//     // Toggle dropdown visibility
//     const toggleDropdown = () => {
//         setIsOpen(!isOpen);
//     };

//     // Handle checkbox change
//     const handleCheckboxChange = (event) => {
//         const { value, checked } = event.target;
//         const id = parseInt(value); // Convert value to integer if needed

//         setSelectedRow((prevSelectedRow) => {
//             const updatedDepartmentIds = checked
//                 ? [...(prevSelectedRow.department_id || []), id]  // Add the value if checked
//                 : (prevSelectedRow.department_id || []).filter((item) => item !== id);  // Remove the value if unchecked

//             return {
//                 ...prevSelectedRow,
//                 department_id: updatedDepartmentIds  // Update the department_id array
//             };
//         });
//     };

//     return (
//         <div className="dropdown">
//             <div className="mb-3">
//                 <label htmlFor="department_id" className="form-label">
//                     Department:
//                 </label>
//                 <select
//                     className="form-select"
//                     name="department_id"
//                     id="department_id"
//                     aria-label="Default select example"
//                     onClick={toggleDropdown}
//                 >
//                     <option value="" disabled hidden>
//                         Select Department
//                     </option>
//                 </select>
//             </div>
//             {isOpen && (
//                 <ul className="dropdown-menu">
//                     {departments.map((item) => (
//                         <li key={item.id}>
//                             <label>
//                                 <input
//                                     type="checkbox"
//                                     value={item.id}
//                                     name="department_id"
//                                     onChange={handleCheckboxChange}
//                                     checked={selectedRow.department_id?.includes(item.id) || false}
//                                 />
//                                 {item.department_name}
//                             </label>
//                         </li>
//                     ))}
//                 </ul>
//             )}
//         </div>
//     );
// };

// export default DropdownCheckbox;



import React, { useEffect, useRef, useState } from "react";

const DropdownCheckbox = ({ departments, selectedRow, setSelectedRow }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (typeof selectedRow.department_id === "string") {
            try {
                const parsedDepartmentId = JSON.parse(selectedRow.department_id);
                setSelectedRow((prevSelectedRow) => ({
                    ...prevSelectedRow,
                    department_id: Array.isArray(parsedDepartmentId) ? parsedDepartmentId : [],
                }));
            } catch (error) {
                console.error("Failed to parse department_id:", error);
            }
        }
    }, [selectedRow.department_id, setSelectedRow]);

    const toggleDropdown = () => {
        setIsOpen(prev => !prev);
    };

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        const id = parseInt(value);

        setSelectedRow((prevSelectedRow) => {
            const updatedDepartmentIds = checked
                ? [...(prevSelectedRow.department_id || []), id]
                : (prevSelectedRow.department_id || []).filter((item) => item !== id);

            return {
                ...prevSelectedRow,
                department_id: updatedDepartmentIds,
            };
        });
    };

    const handleClickOutside = (event) => {
        // console.log('Clicked element:', event.target);
        // console.log('Dropdown ref:', dropdownRef.current);

        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            // console.log('Outside click detected, closing dropdown.');
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="dropdown-checkbox" ref={dropdownRef}>
            <div className="mb-3">
                <label htmlFor="department_id" className="form-label">
                    Department:
                </label>
                <div className="dropdown">
                    <button
                        className="btn btn-light dropdown-toggle"
                        type="button"
                        onClick={toggleDropdown}
                        aria-expanded={isOpen}
                    >
                        
                        {selectedRow.department_id?.length > 0
                            ? `Selected (${selectedRow.department_id.length})`
                            : "Select Department"}
                           <i class="fa-solid fa-chevron-down"></i>
                    </button>
                    {isOpen && (
                        <div className="dropdown-menu show">
                            {departments.map((item) => (
                                <div key={item.id} className="dropdown-item">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value={item.id}
                                            onChange={handleCheckboxChange}
                                            checked={selectedRow.department_id?.includes(item.id) || false}
                                        />
                                        {item.department_name}
                                    </label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DropdownCheckbox;
